// Testimonials.js
import React from 'react'
import { motion } from 'framer-motion'
import { StaticImage } from 'gatsby-plugin-image'

const Testimonials = () => {
  const testimonials = [
    {
      quote: "Exceeded our expectations with innovative designs that brought our vision to life - a truly remarkable resume builder.",
      author: "Samantha Johnson",
      image: "../images/testimonial1.jpg"
    },
    {
      quote: "Their ability to capture our brand essence in every project is unparalleled - an invaluable creative collaborator.",
      author: "Isabella Rodriguez",
      image: "../images/testimonial2.jpg"
    },
    {
      quote: "Creative geniuses who listen, understand, and craft captivating visuals - an agency that truly understands our needs.",
      author: "Gabrielle Williams",
      image: "../images/testimonial3.jpg"
    }
  ]

  const bottomTestimonials = [
    {
      quote: "A refreshing and imaginative platform that consistently delivers exceptional results - highly recommended for any job seeker.",
      author: "Victoria Thompson",
      image: "../images/testimonial4.jpg"
    },
    {
      quote: "Their team's AI expertise and strategic approach resulted in remarkable resumes - a reliable career partner.",
      author: "John Peter",
      image: "../images/testimonial5.jpg"
    },
    {
      quote: "From concept to execution, their creativity knows no bounds - a game-changer for our brand's success.",
      author: "Natalie Martinez",
      image: "../images/testimonial6.jpg"
    }
  ]

  return (
    <div className="relative py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-4">
            Words of praise from others <br />
            <span className="text-indigo-600">about our presence.</span>
          </h2>
        </motion.div>

        {/* Top Testimonials */}
        <div className="grid md:grid-cols-3 gap-6 mb-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-neutral-50 rounded-2xl p-8"
            >
              <div className="mb-6 text-indigo-600 text-4xl">
                "
              </div>
              <p className="text-lg text-neutral-700 mb-8">
                {testimonial.quote}
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-neutral-200">
                  {/* Replace with actual StaticImage when you have images */}
                </div>
                <div>
                  <h4 className="font-semibold text-neutral-900">
                    {testimonial.author}
                  </h4>
                  <p className="text-sm text-neutral-500">
                    {testimonial.position}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom Testimonials */}
        <div className="grid md:grid-cols-3 gap-6">
          {bottomTestimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (index + 3) * 0.1 }}
              className="bg-neutral-50 rounded-2xl p-8"
            >
              <div className="mb-6 text-indigo-600 text-4xl">
                "
              </div>
              <p className="text-lg text-neutral-700 mb-8">
                {testimonial.quote}
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-neutral-200">
                  {/* Replace with actual StaticImage when you have images */}
                </div>
                <div>
                  <h4 className="font-semibold text-neutral-900">
                    {testimonial.author}
                  </h4>
                  <p className="text-sm text-neutral-500">
                    {testimonial.position}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Testimonials